import { helpers, HathorWallet, Connection } from "@hathor/wallet-lib";

const wallet = {
  async StartWallet() {
    // Config for wallet
    const seed =
      "range wonder roof trumpet soon urge unaware satisfy confirm kidney critic rookie wild used merry teach smooth puzzle salute desk pepper jeans creek valve";
    const pin = "1234";
    const password = "testwallet";

    // Start connection object
    const connection = new Connection({
      network: "testnet",
      servers: ["https://node1.golf.testnet.hathor.network/v1a/"]
    });
    console.log("Connection created");

    // Wallet object to start wallet
    const wallet = new HathorWallet({
      connection: connection,
      seed: seed,
      pinCode: pin,
      password,
      tokenUid: "00"
    });

    console.log("Starting...");

    // Let's start wallet
    await wallet.start();

    // Check state of wallet
    wallet.on("state", async (state) => {
      if (state === HathorWallet.ERROR) {
        // ERROR
        console.log("OOps something went wrong.");
      } else if (wallet.isReady()) {
        var address = "WZwkgSjMD9vNFbBLa88N8T1D69JMRuhH5W";
        var value = 5;
        var token_id = "00";
        var changeAddress = null;
        // READY
        console.log("Current Address -->");
        console.log(await wallet.getCurrentAddress());

        console.log("Starting transaction...");
        console.log(token_id);

        await wallet.sendTransaction(address, value, {
          token: token_id,
          changeAddress
        });
        console.trace();
      }
    });

    wallet.on("new-tx", async (tx) => {
      let message = "No new tx.";
      if (helpers.isBlock(tx)) {
        message = "You've found a new block! Click to open it.";
      } else {
        message = "You've received a new transaction! Click to open it.";
      }
      console.log(message);
      console.log("Transaction --> " + tx.tx_id);
    });
  }
};

export default wallet;
